module.exports = __webpack_public_path__ + "img/picture_20.7d730222.png";